import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dolgunun-duygusal-etkileri-mecazi/page.tsx");
